import { format } from 'date-fns';
import api from 'lib/trpcClient';
import downloadFile from 'utils/downloadFile';
import { CalendarDay, FileType } from 'further-ui/utils';

export function usePerformanceFeeSimulation() {
  const exportPerformanceFeeSimulationMutation =
    api.fund.exportPerformanceFeeSimulation.useMutation();

  const exportPerformanceFeeSimulation = async (params: {
    firmId?: string;
    fundName?: string;
    tagId?: string;
    snapshotDate?: CalendarDay;
    fundStatus?: Array<string>;
    fullyDeployed?: boolean;
    startDate?: CalendarDay;
    endDate?: CalendarDay;
    fundId?: string;
  }) => {
    try {
      const { file, simulationDate } =
        await exportPerformanceFeeSimulationMutation.mutateAsync(params);

      // Convert base64 to blob and download
      const binaryString = atob(file);
      const bytes = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      const blob = new Blob([bytes], {
        type: FileType.ExcelAlt,
      });

      const todayDate = format(new Date(), 'dd-MM-yyyy');
      const simDate = format(simulationDate, 'dd-MM-yyyy');

      downloadFile(
        blob,
        `Performance fee export ${todayDate} (sim date ${simDate}).xlsx`,
      );
    } catch (error) {
      console.error('Error exporting performance fee simulation:', error);
      throw error;
    }
  };

  return {
    exportPerformanceFeeSimulation,
    isExporting: exportPerformanceFeeSimulationMutation.isPending,
  };
}
